export default "__VITE_ASSET__d49CTxHk__"